var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-counter-list"},_vm._l((_vm.steps),function(step){return _c('StepCounter',{key:step,staticClass:"step-counter-list__item",attrs:{"text":_vm.getStepText(step),"theme":_vm.getTheme(step)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }